const HEADER_GAP = 16;

function getTargetFromHash(hash) {
    if (!hash || hash === '#') {
        return null;
    }

    try {
        return document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (error) {
        return document.getElementById(hash.slice(1));
    }
}

function getStickyHeaderOffset() {
    const header = document.querySelector('[data-site-header]');
    if (!header) {
        return HEADER_GAP;
    }

    const rect = header.getBoundingClientRect();
    return rect.height + HEADER_GAP;
}

function scrollHashTargetIntoView(hash = window.location.hash) {
    const target = getTargetFromHash(hash);
    if (!target) {
        return false;
    }

    const top = target.getBoundingClientRect().top + window.scrollY - getStickyHeaderOffset();
    window.scrollTo({
        top: Math.max(top, 0),
        behavior: 'auto',
    });

    return true;
}

function isSamePageHashLink(link) {
    if (!link.hash) {
        return false;
    }

    return link.origin === window.location.origin
        && link.pathname === window.location.pathname
        && link.search === window.location.search;
}

export default function setupAnchorOffsetScroll() {
    if (window.location.hash) {
        requestAnimationFrame(() => {
            scrollHashTargetIntoView();
            window.setTimeout(scrollHashTargetIntoView, 100);
        });
    }

    window.addEventListener('hashchange', () => {
        requestAnimationFrame(() => scrollHashTargetIntoView());
    });

    document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href*="#"]');
        if (!link || !isSamePageHashLink(link)) {
            return;
        }

        event.preventDefault();
        window.history.pushState(null, '', link.href);
        requestAnimationFrame(() => scrollHashTargetIntoView(link.hash));
    });
}
